<app-sidebar 
  layoutVariant="provider"
  [menuItems]="menuItems" 
  [callToAction]="callToAction"
  [footerItems]="footerItems"
  title="Org Admin">
</app-sidebar>



